<template>
  <div
    class="employee-inner employee-inner-permission"
    :class="{'employee-inner-full' : tabActive}"
  >
    <ListInfo :loadData="loadData" :setup-panel="trainingList" @open-detail="openDetail('training', $event)" @open-modal="openModal($event)" />

    <ListInfo :loadData="loadData" :setup-panel="punishmentList" @open-detail="openDetail('punishment', $event)" @open-modal="openModal($event)" />
  </div>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'

  import ListInfo from "../EmployeeInfo/ListInfo.vue"

  export default {
    components: {
      ListInfo
    },

    props: {
      tabActive: { type: Boolean, default: false },
      loadData: { type: Boolean, default: false },
      thisMonthnow: { type: String, default: "" },
      trainingWaiting: { type: Object, default: [] },
      trainingWaitingfull: { type: Object, default: [] },
      trainingApprove: { type: Object, default: [] },
      trainingApprovefull: { type: Object, default: [] },
      trainingReject: { type: Object, default: [] },
      trainingRejectfull: { type: Object, default: [] },
      punishmentPayroll: { type: Object, default: [] },
      punishmentPayrollfull: { type: Object, default: [] },
      punishmentPerfomance: { type: Object, default: [] },
      punishmentPerfomancefull: { type: Object, default: [] },
      punishmentPosition: { type: Object, default: [] },
      punishmentPositionfull: { type: Object, default: [] },
      punishmentTerminated: { type: Object, default: [] },
      punishmentTerminatedfull: { type: Object, default: [] }
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()

      const trainingList = ref({})
      const punishmentList = ref({})


      const openDetail = (type, data) => {
        emit("open-detail", {type, data})
      }


      const openModal = (data) => {
        // console.log("Cek ges", data)
        emit("open-modal", data)
      }


      onBeforeMount(() => {

      })

      onMounted(() => {

      })

      watchEffect(() => {
        if(
          props.trainingWaiting ||
          props.trainingWaitingfull ||
          props.trainingApprove ||
          props.trainingApprovefull ||
          props.trainingReject ||
          props.trainingRejectfull
        ) {
          trainingList.value = {
            id: "training_container",
            title: "Training",
            month: null,
            child: [
              {
                id: "trainingWaiting",
                title: "Waiting for Approval",
                container_color: 'yellow',
                dataShow: props.trainingWaiting,
                dataFull: props.trainingWaitingfull
              },
              {
                id: "trainingApprove",
                title: "Approved",
                container_color: 'green',
                dataShow: props.trainingApprove,
                dataFull: props.trainingApprovefull
              },
              {
                id: "trainingReject",
                title: "Rejected",
                container_color: 'red',
                dataShow: props.trainingReject,
                dataFull: props.trainingRejectfull
              }
            ]
          }
        }

        if(
          props.punishmentPayroll ||
          props.punishmentPayrollfull ||
          props.punishmentPerfomance ||
          props.punishmentPerfomancefull ||
          props.punishmentPosition ||
          props.punishmentPositionfull ||
          props.punishmentTerminated ||
          props.punishmentTerminatedfull
        ) {
          punishmentList.value = {
            id: "punishment_container",
            title: "Punishment",
            month: null,
            child: [
              {
                id: "punishmentPayroll",
                title: "Consider in Payroll",
                container_color: 'yellow',
                dataShow: props.punishmentPayroll,
                dataFull: props.punishmentPayrollfull
              },
              {
                id: "punishmentPerfomance",
                title: "Consider in Perfomance",
                container_color: 'green',
                dataShow: props.punishmentPerfomance,
                dataFull: props.punishmentPerfomancefull
              },
              {
                id: "punishmentPosition",
                title: "Relate to Position",
                container_color: 'yellow',
                dataShow: props.punishmentPosition,
                dataFull: props.punishmentPositionfull
              },
              {
                id: "punishmentTerminated",
                title: "Is Terminated",
                container_color: 'red',
                dataShow: props.punishmentTerminated,
                dataFull: props.punishmentTerminatedfull
              }
            ]
          }
        }
      })

      return {
        trainingList,
        punishmentList,
        openDetail,
        openModal
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
